<template>
    <div class="vue timparty-band-party-collection band-party-collection">

        <div class="band-party-collection" v-if="contest_ready && !is_ended">
          <div class="row m-auto">
            <div class="col-lg-6 p-0">
              <img :src="contest_image" alt="" class="w-100">
            </div>
            <div class="col-lg-6 p-4 p-md-0">
              <div class="half-container p-3 p-md-5">

                  <BadgeCounter :hide-info="false" label-text="Hai a disposizione"/>

                <h2 class="section-title my-3">Party Collection</h2>
                <p class="section-content">
                  <b>Colleziona i badge</b> per garantirti un'opportunità unica: ogni badge infatti ti offre la <b>possibilità di vincere il premio esclusivo</b>, solo per i clienti TIM Party.

                </p>
                <a :href="contest_url" class="btn btn-lg btn-white mt-3 cta-generic">Scopri di più</a>
              </div>
            </div>
          </div>
        </div>

    </div>
</template>

<script>

    /* eslint-disable */

    import moment        from "moment";
    import TimPartyMixin from '../mixins/TimPartyMixin';
    import BadgeCounter  from './BadgeCounter';


    export default {
      name: 'BandPartyCollection',
      components: { BadgeCounter },
      mixins: [ TimPartyMixin ],
      data: function(){
        return {

          current_contest: {},
          contest_ready: false,
          is_ended: false,
        };
      },
      props: {
        image: {
          type: String,
        },
        url: {
          type: String,
          default: '/party-collection',
        },
        endDate: {
          type: String,
          default: '20220108235959'
        }
      },
      mounted: function(){

        if( this.user.id )
          this.getContest();
          this.isEnded();
      },

      methods: {
        getContest: function( ){

          if( !this.user.endpoints.contest )
            return false;

          if( !this.user.party_collection_current_code )
            return false;


          this.setApiUrl( this.user.endpoints.contest );

          var self = this;

          var payload = {
            action: 'get',
            access_token: this.access_token,
            contest_code: this.user.party_collection_current_code,

          };

          this.loading = true;

          this.callApiGet( payload, function( response){

            self.loading = false;
            self.current_contest = response.data;

            self.contest_ready = true;

          } );

        },
        isEnded: function () {
          let end_date = moment(this.endDate, 'YYYYMMDDHHmmss');
          const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
          });

          let today = params.today ? moment(params.today, 'YYYYMMDDHHmmss') : moment();
          this.is_ended = today.isAfter(end_date);
        },
      },


      watch: {
        user: function(new_val){
          this.getContest();
        }
      },

      computed: {
        contest_url: function(){
          if( _.has( this.current_contest, 'extra.url' )){
            return this.current_contest.extra.url;
          }
          else if( this.url ){
            return this.url;
          }
          else{
            return '/party-collection';
          }
        },

        contest_image: function(){

          if( _.has( this.current_contest, 'extra.images.featured' )){
            return this.current_contest.extra.images.featured[0];
          }
          else if( _.has( this.current_contest, 'extra.images.slider' )){
            return this.current_contest.extra.images.slider[0];
          }
          else if( this.image ){
            return this.image;
          }
          else{
            return this.modulePath('/js/src/assets/images/partycollection.png');
          }
        },
      }
  }
  </script>


